<script>
import PlanCustomEditField from './PlanCustomEditField.vue';

export default {
  props: ["component", "handler"],
  components: {PlanCustomEditField},
  methods: {
  },
  data: function () {
    return {
    };
  },
  computed: {
  }
};
</script>

<template>
  <f-modal-base
    closable
    :title2="component.title"
    @close="handler.action(component, 'close')">
    
    <template #content>
      <plan-custom-edit-field 
        :component="component.duration" :handler="handler"
        title="Durée" description="durée, sous la forme '1 month', '2 years',...">
      </plan-custom-edit-field>
      <plan-custom-edit-field 
        :component="component.minutes" :handler="handler"
        title="Minutes" description="heures disponibles, mais en minutes">
      </plan-custom-edit-field>
      <plan-custom-edit-field 
        :component="component.viewers_limit" :handler="handler"
        title="Maximum de viewers" description="Maximum de viewers d'un player">
      </plan-custom-edit-field>
      <plan-custom-edit-field 
        :component="component.vod_availability" :handler="handler"
        title="Disponibilité VOD" description="durée de dispo des fichiers VOD, sous la forme '1 month', '2 years',...">
      </plan-custom-edit-field>

    </template>

    <template #actions>
      <f-button type="tertiary" @click="handler.action(component, 'close')">close</f-button>
      <f-button type="primary" @click="handler.action(component, 'start')">START PLAN</f-button>
    </template>

  </f-modal-base>
</template> 

<style lang="scss">
</style>